import { useState } from 'react';
import { Monitor, Moon, Sun } from 'lucide-react';
import Icon from '../../../../components/primitives/Icon.jsx';
import { applyThemePreference } from '../../../../lib/theme/applyThemePreference.js';
import { readThemePreference } from '../../../../lib/theme/readThemePreference.js';

const OPTIONS = [
  { value: 'light', label: 'Light', icon: Sun },
  { value: 'dark', label: 'Dark', icon: Moon },
  { value: 'system', label: 'System', icon: Monitor }
];

const ThemeSwitcher = () => {
  const [preference, setPreference] = useState(() => readThemePreference({ search: window.location.search, storage: window.localStorage }));

  const handleSelect = (value) => {
    setPreference(value);
    applyThemePreference({ preference: value });
  };

  return (
    <div className="gallery-theme-switcher" role="group" aria-label="Theme">
      {OPTIONS.map((option) => (
        <button key={option.value} type="button" className="gallery-theme-switcher__option" aria-pressed={preference === option.value} onClick={() => handleSelect(option.value)}>
          <Icon icon={option.icon} size="sm" />
          {option.label}
        </button>
      ))}
    </div>
  );
};

export default ThemeSwitcher;
